<template>
  <div class="row select-trading-name-dropdown w-100">
    <div class="mb-3 w-100">
      <select
        id="trading_name"
        ref="input"
        v-model="tradingId"
        :class="{
          'form-control': true,
          'form-control-lg': true,
          'trading-name-tom-selector': !styleCreateCustomer,
          'input-new-design-customer-attribute': styleCreateCustomer,
        }"
        name="trading_name"
        placeholder="Select Trading Name"
      ></select>
    </div>

    <confirmation-popup
      title="Notice"
      message="Would you like to Change Booking trading name  to the new customer customer trading name or keep current ? "
      confirm-btn-text="Change"
      cancel-btn-text="Keep Current"
      @on-confirm="changeTradingName"
      id="ask_change_trading_name_because_of_changing_customer"
    >
    </confirmation-popup>
  </div>
</template>

<script>
import { EventBus } from "@/events/event-bus";
import TomSelect from "tom-select";
import {
  bookingEditTradnigNameId,
  inquiryEditTradnigNameId,
} from "@/modules/common/api";
import ConfirmationPopup from "@/modules/common/components/ConfirmationPopup.vue";

export default {
  name: "SelectTradingName",
  components: { ConfirmationPopup },
  props: {
    value: null,
    styleCreateCustomer: false,
    trading_id: 0,
    viewPage: 0,
    bookingId: "",
    isInquiry: {
      default() {
        return false;
      },
    },
    inquiryId: {
      default() {
        return 0;
      },
    },
  },
  data() {
    return {
      names: [],
      select: null,
      customer: {},
    };
  },
  computed: {
    tradingNames() {
      if (this.$store.state && this.$store.state.tradingNames) {
        this.names = this.$store.state.tradingNames.data;
        return this.$store.state.tradingNames.data;
      }
    },
    tradingId() {
      return this.value !== undefined ? this.value : this.trading_id;
    },
  },
  mounted() {
    EventBus.$on("onCustomerChanged", (customer) => {
      /** && !this.trading_id  ???? when admin edits inquiry then get  inquiry trading name, not customer trading name   **/
      if (
        customer &&
        customer.trading_name &&
        !this.trading_id &&
        this.select
      ) {
        this.select.addItem(customer.trading_name);
      }
    }),
      EventBus.$on("oncustomerChangedFromViewBooking", (customer) => {
        let vm = this;
        if (
          vm.viewPage &&
          customer.trading_name &&
          customer.trading_name != vm.tradingId
        ) {
          $("#ask_change_trading_name_because_of_changing_customer").modal(
            "show"
          );
          this.customer = customer;
        }
      });

    setTimeout(() => {
      this.initiateDropdown(this.tradingNames);
      this.listenToTomSelectEvents();
    }, 1000);
  },
  methods: {
    initiateDropdown(names) {
      let vm = this;
      this.$nextTick(() => {
        // I added the variable to window to use it in jquery in other pages
        this.select = window.tradingNameSelect = new TomSelect(
          this.$refs["input"],
          {
            preload: true,
            labelField: "trading_name",
            searchField: ["trading_name"],
            valueField: "trading_name_id",
            highlight: false,
            persist: false,
            plugins: ["dropdown_input"],
            load: function (query, callback) {
              let self = this;

              if (self.loading > 1) {
                callback();
                return;
              }
              callback(vm.names);
              self.settings.load = null;
            },
          }
        );
        this.select.on("load", (value, item) => {
          let selected_trading_id = false;

          if (value[0]) {
            selected_trading_id = value[0].trading_name_id;
          }
          if (this.value) {
            selected_trading_id = this.value;
            this.trading_id = this.value;
          }
          if (this.trading_id) {
            selected_trading_id = this.trading_id;
          }
          if (selected_trading_id) {
            this.select.addItem(selected_trading_id);
          }
        });

        this.select.on("item_add", (value, item) => {
          let tradingName = this.names.find(
            (name) => name.trading_name_id == value
          );
          EventBus.$emit("onTradingNameChanged", tradingName);
          document
            .getElementById("trading_name-ts-control")
            .setAttribute("readonly", true);
          if (this.viewPage) {
            if (this.trading_id != value) {
              if (this.isInquiry && this.inquiryId) {
                inquiryEditTradnigNameId(this.inquiryId, value)
                  .then((response) => {
                    $.notify(response.data.message, response.data.type);
                  })
                  .catch((error) => {});
              } else {
                bookingEditTradnigNameId(this.bookingId, value)
                  .then((response) => {
                    $.notify(response.data.message, response.data.type);
                  })
                  .catch((error) => {});
              }
            }
          }
        });

        this.select.on("item_remove", (value, item) => {
          EventBus.$emit("onTradingNameChanged", null);
          document
            .getElementById("trading_name-ts-control")
            .removeAttribute("readonly");
          this.tradingId = value;
        });
      });
    },
    listenToTomSelectEvents() {
      try {
        this.select.on("item_add", (value, item) => {
          let tradingName = this.names.find(
            (name) => name.trading_name_id == value
          );
          EventBus.$emit("onTradingNameChanged", tradingName);
        });
      } catch (e) {
        console.warn(e.message);
      }
    },
    changeTradingName() {
      this.select.addItem(this.customer.trading_name);
    },
  },
  watch: {
    // Watch for changes in the computed property
    tradingNames(newNames) {
      // Update the names data property when the computed property changes
      this.names = newNames || [];
    },
    tradingId: {
      handler(val, oldVal) {
        if (!val) val = this.names[0].trading_name_id;
        this.select.addItem(val);
        this.$emit("input", parseInt(val));
      },
    },

    deep: true,
    immediate: true,
  },
};
</script>

<style scoped lang="scss">
@import "bootstrap/scss/bootstrap";
@import "tom-select/dist/css/tom-select.min.css";
@import "tom-select/dist/css/tom-select.bootstrap5.min.css";
</style>
